import { AxiosRequestConfig } from 'axios';
import { ParsedQuery } from 'query-string';
import { ContentType } from '../client';
import type { Cancelable, Response } from '../types';
import AxiosClient from './axiosClient';

export default class IubendaAxiosClient extends AxiosClient {
  constructor(baseURL: string, iubendaApiKey: string) {
    super(baseURL);
    this.httpClient.defaults.headers.common.ApiKey = iubendaApiKey;
  }

  async post<T>(
    path: string,
    data: ParsedQuery = {},
    contentType: ContentType = ContentType.JSON,
    options?: AxiosRequestConfig
  ): Promise<Response<T> & Cancelable> {
    const { httpClient } = this;
    const config = {
      headers: {
        'Content-Type': contentType,
      },
      ...options,
    };
    return httpClient.post(path, data, config);
  }
}
